import { IncidentQuery } from '@/graphql/generated/operations'
import { EventType } from '@/graphql/generated/schemas'
import { DOWN, SCROLL, UP } from '@/utils/analytics'
import { removeUnderscoreAndCapitalize } from '@/utils/formats'

import { EventsT } from '../types/types'

// Mixpanel events
export const VIEW_TL_EVENT = 'View trace logs'
export const VIEW_TL_TAB_EVENT = 'tab - trace logs'
export const DEVICES_TAB_EVENT = 'Devices'
export const FACILITIES_TAB_EVENT = 'Facilities'
export const INCIDENT_TAB_EVENT = 'Incident'
export const ADDITIONAL_TL_EVENTS = 'viewing additional trace log events'
export const SCROLL_UP_EVENT = `${SCROLL} ${UP} ${ADDITIONAL_TL_EVENTS}`
export const SCROLL_DOWN_EVENT = `${SCROLL} ${DOWN} ${ADDITIONAL_TL_EVENTS}`

/**
 * Returns a formatted event name by capitalizing and removing underscores from the event type.
 * If the event type is 'Other' or null, attempts to use the ACS event type.
 * Returns 'Unknown' if neither type is available.
 *
 * @param event - The event object to extract the name from.
 * @returns The formatted event name or 'Unknown'.
 */
export const getEventName = (event: EventsT) => {
  if (event?.type !== EventType.Other && event?.type !== null) {
    return removeUnderscoreAndCapitalize(event?.type)
  }
  if (event?.acsEventType) {
    return removeUnderscoreAndCapitalize(event?.acsEventType)
  }
  return 'Unknown'
}

export const getMixpanelEventData = (incident: IncidentQuery['incident']) => ({
  device_id: incident?.devices[0]?.id,
  facility_id: incident?.facility?.id,
  incident_id: incident?.id,
})
